export enum MeasurementUnit {
    Imperial = 1,
    Metric = 2
}
